import React from 'react';
import { SectionHead } from '../SectionHead';

interface Props {
  id: string;
  n: string;
  title: React.ReactNode;
  sub?: React.ReactNode;
  tone?: string;
  children: React.ReactNode;
}

// One section of the read, in the Briefing's shape: a numbered badge, a big
// question for a headline, a grey sub paragraph, then the content. The read
// and the Briefing are read by the same marketer, so they share one rhythm.
export const ReadSection: React.FunctionComponent<Props> = ({ id, n, title, sub, tone, children }) => (
  <section id={id} style={{ paddingTop: 44 }}>
    <SectionHead q={n} title={title} sub={sub} tone={tone} />
    {children}
  </section>
);
